export interface NewsItem {
  id: string;
  category: '产品进展' | '行业洞察' | '合作实践';
  date: string;
  title: string;
  summary: string;
  image?: string;
}

export const latestNews: NewsItem[] = [
  {
    id: 'NEWS-001',
    category: '产品进展',
    date: '2026.09.08',
    title: '华辉数智发布「数字货架」最新进展',
    summary:
      '本次更新解决县域门店商品展示与数据回流难题，面向区域运营方与商户开放，支持云端远程投放与销售数据实时上云。',
    image:
      'https://readdy.ai/api/search-image?query=Realistic%20bright%20photograph%20of%20a%20modern%20retail%20store%20interior%20with%20neatly%20arranged%20product%20shelves%20and%20a%20digital%20display%20screen%20mounted%20on%20the%20shelf%20showing%20product%20information%2C%20warm%20daytime%20natural%20lighting%2C%20clean%20organized%20shop%20atmosphere%20conveying%20digital%20retail%20and%20cloud%20shelf%20management%2C%20editorial%20business%20photography%2C%20sharp%20detail%2C%20harmonious%20composition%2C%20no%20text%2C%20no%20watermark&width=1200&height=750&seq=news-digital-shelf-01&orientation=landscape&nocache=true',
  },
  {
    id: 'NEWS-002',
    category: '行业洞察',
    date: '2026.08.28',
    title: '从业务流程出发，重新理解数智化建设',
    summary:
      '数智化不是简单上线系统，而是沿着「业务流—数据流—价值流」重新梳理经营逻辑，让技术真正服务于业务目标。',
  },
  {
    id: 'NEWS-003',
    category: '合作实践',
    date: '2026.08.15',
    title: '华辉数智与「大庄科」开展「乡村数字商业样板间」合作',
    summary:
      '当前处于样板间建设与试点验证阶段，已获得公开授权，后续进展将持续披露。',
  },
];